import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'temptik-feature-card',
  templateUrl: './feature-card.component.html',
  styleUrls: ['./feature-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureCardComponent {}
